import getParameterByName from '../utils/getParameterByName';

function heroScroll() {
  const $disciplineItems = document.querySelectorAll('.js-tournament-item');

  if (!$disciplineItems.length) return [];

  const controller = new ScrollMagic.Controller();

  const scenes = [];

  $disciplineItems.forEach(($disciplineItem) => {
    const $img = $disciplineItem.querySelector('.js-tournament-item-img');

    const animation = new TimelineMax().fromTo(
      $img,
      1,
      {
        scale: 1.3,
      },
      {
        scale: 1,
      }
    );

    const animationScene = new ScrollMagic.Scene({
      triggerElement: $disciplineItem,
      triggerHook: 'onCenter',
      duration: '100%',
    })
      .setTween(animation)
      .addTo(controller);

    if (getParameterByName('animationDebug') == '1') {
      animationScene.addIndicators();
    }

    scenes.push(animationScene);
  });

  return scenes;
}


export default function () {
  const heroScrollScene = heroScroll();

  const scenes = [];

  scenes.push(heroScrollScene);

  if (!scenes.length) return;

  window.updateScenes = () => {
    scenes.forEach((scene) => {
      scene.update(true);
      scene.refresh();
    });
  };

  let resizeTimer = null;

  $(window).on('resize', () => {
    clearTimeout(resizeTimer);

    resizeTimer = setTimeout(() => {
      window.updateScenes();
    }, 250);
  });
}



// WEBPACK FOOTER //
// ./assets/scripts/components/tournamentAnimations.js